var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-accordeon.ts
import { isPrinting } from "@adornis/base/client/frontend-helpers/index.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { RXController } from "../../controllers/RXController.js";
import { event } from "../../decorators/event.js";
import { css } from "../../directives/css.js";
import "../../renderable.js";
import { DesignSystem } from "../theming/design.js";
import { xComponents } from "../x-components.js";
import "./x-flex.js";
import "./x-hr.js";
import "./x-toggle-content.js";
var XAccordeon = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.space = "sm";
    this.items = new RXController(this, []);
    this.selected = -1;
    this.isPrinting = new RXController(this, isPrinting);
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          "@media print": {
            [`${DesignSystem.prefix}-text`]: { display: "initial !important" }
          }
        }
      }
    ];
  }
  render() {
    return xComponents(html`
      <x-flex space=${this.space}>
        ${repeat(
      this.items.value ?? [],
      (item, index) => html` ${this._singleToggleContent(item, index)} ${this.spacer(index)} `
    )}
      </x-flex>
    `);
  }
  _singleToggleContent(item, index) {
    return xComponents(html`
      <x-toggle-content
        ${css(this.selected === index || this.isPrinting.value ? { marginBottom: "0" } : {})}
        .label=${item.title}
        .content=${typeof item.text === "function" ? item.text : null}
        @open-changed="${(e) => {
      if (e.detail.value !== void 0 && e.detail.value !== null) {
        if (e.detail.value && this.selected !== index)
          this.selected = index;
        else if (!e.detail.value && this.selected === index)
          this.selected = -1;
      }
    }}"
        ?open=${this.selected === index || this.isPrinting.value}
      >
        ${typeof item.text !== "function" ? typeof item.text === "string" ? xComponents(html` <x-text> ${item.text} </x-text> `) : item.text : nothing}
      </x-toggle-content>
    `);
  }
  spacer(index) {
    return index < (this.items.value?.length ?? 0) - 1 ? xComponents(html` <x-hr></x-hr> `) : nothing;
  }
};
__decorateClass([
  property()
], XAccordeon.prototype, "space", 2);
__decorateClass([
  state()
], XAccordeon.prototype, "items", 2);
__decorateClass([
  state(),
  event
], XAccordeon.prototype, "selected", 2);
__decorateClass([
  state()
], XAccordeon.prototype, "isPrinting", 2);
XAccordeon = __decorateClass([
  customElement("x-accordeon")
], XAccordeon);
export {
  XAccordeon
};
